/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrowLinkCurveDash = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m6 1.586 3.707 3.707-1.414 1.414L7 5.414V8c0 .492.118.954.326 1.362l-1.781.91A4.983 4.983 0 0 1 5 8V5.414L3.707 6.707 2.293 5.293zM19 18v-2c0-.409-.081-.796-.227-1.148l1.847-.766c.245.59.38 1.238.38 1.914v2zm0 2v2h2v-2zm-9-7a4.983 4.983 0 0 1-2.271-.545l.91-1.78c.407.207.869.325 1.361.325h2v2zm7.914-1.62A4.987 4.987 0 0 0 16 11h-2v2h2c.409 0 .796.081 1.148.227z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgArrowLinkCurveDash as ArrowLinkCurveDash };
